import { useInformationList } from "@/api/services/main/information";
import { NotificationList } from "@/components/commons/notification/NotificationList";
import { InfiniteScroll } from "@/components/elements/InfiniteScroll";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { Tab } from "@/components/elements/Tab";
import { NOTIFICATION_TAB, NOTIFICATION_TAB_LABEL, TNotificationTab } from "@/features/dashboard/constants/notificationTab";
import { FC, useState } from "react";

export type TNotificationProps = {
  isSingleLine?: boolean;
  isHideContent?: boolean;
};

export const Notification: FC<TNotificationProps> = ({ isSingleLine = false, isHideContent = false }) => {
  const [tab, setTab] = useState<TNotificationTab>(NOTIFICATION_TAB.ALL);
  const {
    dataFormatter: informationListData,
    isLoading,
    fetchNextPage,
    hasNextPage,
  } = useInformationList({
    types: tab === NOTIFICATION_TAB.ALL ? ["important", "system", "irohana"] : tab,
  });

  return (
    <Tab
      value={tab}
      onChange={(_, tab) => setTab(tab.toString())}
      options={Object.values(NOTIFICATION_TAB).map((tab) => ({ label: NOTIFICATION_TAB_LABEL[tab], value: tab }))}
    >
      {!informationListData || isLoading ? (
        <LoadingArea height={100} />
      ) : (
        <InfiniteScroll loadMore={fetchNextPage} hasMore={hasNextPage}>
          <NotificationList
            data={informationListData.map((notification) => ({
              id: notification.id,
              description: notification.content,
              time: notification.startDate,
              title: notification.title,
              type: notification.type,
              filePath: notification.filePath,
            }))}
            isSingleLine={isSingleLine}
            isHideContent={isHideContent}
          />
        </InfiniteScroll>
      )}
    </Tab>
  );
};
